import { useEffect } from 'react';
import { useSubscriptionManager } from './SubscriptionManagerContext';

export type SubscriptionOptions<T> = {
  query: string;
  variables: object;
  callback: (result: T) => void;
  onError?: (error: string) => void;
};

//Note: a flaw of this design is that if only one of the subscription options change
//it will have to recreate all the subscriptions instead of only one, which is a pity.
function useNewSubscriptions(options: Array<SubscriptionOptions<any>>, customName: string) {
  const { addSubscriber, generateSubscriptionKey, removeSubscriber } = useSubscriptionManager();

  useEffect(() => {
    const callbackIds: { key: string; callbackId: string }[] = [];

    options.forEach(async (sub) => {
      const key = generateSubscriptionKey(sub.query, sub.variables);

      console.log('DEBUG >> useNewSubscriptions subscribe', customName, key);
      const newCallbackId = await addSubscriber(
        key,
        customName,
        sub.query,
        sub.variables,
        sub.callback,
        sub.onError
      );
      callbackIds.push({
        key,
        callbackId: newCallbackId,
      });
    });

    return () => {
      console.log('DEBUG >> useNewSubscriptions cleanup', customName);
      callbackIds.forEach((elem) => {
        console.log(
          'DEBUG >> useNewSubscriptions cleanup elem',
          customName,
          elem.key,
          elem.callbackId
        );
        removeSubscriber(elem.key, elem.callbackId);
      });
    };
  }, [options]);
}

export default useNewSubscriptions;
